import PropTypes from 'prop-types';

function MMDeliInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11292)">
                <path
                    d="M3.03795 18.3162C3.03795 18.3162 2.58533 18.5802 2.66076 19.4779C2.76638 20.7717 3.79231 20.1267 5.46701 20.1757L27.2154 18.2898C27.2154 18.2898 29.52 18.2559 29.4785 17.3016C29.437 16.3473 28.3054 16.5472 28.3054 16.5472L3.03795 18.3162Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.98462 20.3037C4.02234 20.7337 4.15435 23.1062 5.30853 23.9435C6.46271 24.7808 9.29536 24.1095 13.7423 23.7247C18.1893 23.34 25.8122 22.9704 26.8004 22.7026C27.2876 22.5793 27.7222 22.3027 28.04 21.9135C28.3579 21.5243 28.5422 21.0432 28.5656 20.5413C28.5789 19.7581 28.5107 18.9756 28.362 18.2065L3.98462 20.3037Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.99267 15.9888C2.99267 15.9888 1.95164 19.0478 3.60748 18.9346C7.8093 18.6442 13.5387 17.6484 15.7188 17.8219C17.8989 17.9954 18.3063 20.2849 19.6604 21.1638C21.2219 22.1784 22.0857 20.5226 22.9796 17.3919C23.3756 16.1321 26.1329 17.0864 28.2866 16.5508C29.9952 16.1397 30.2819 14.9591 29.2936 13.9596C28.5393 13.2052 24.0885 12.6432 15.2738 13.4353C6.45898 14.2274 2.99267 15.9888 2.99267 15.9888Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.44166 13.922C3.44166 13.922 1.70662 13.922 1.2804 15.227C0.790063 16.7131 2.80799 17.4901 4.67505 17.3279C5.72561 17.2845 6.74373 16.9516 7.61708 16.3661C8.12145 15.9934 8.54812 15.5257 8.8731 14.9894C8.8731 14.9894 9.38229 16.7433 12.3658 16.5924C13.95 16.517 15.04 15.9361 15.7906 14.3972C16.7411 15.8305 18.1895 16.3284 19.9698 15.9927C21.5276 15.7023 22.6478 13.888 22.6478 13.888C23.6075 14.5781 24.7094 15.0446 25.8727 15.2534C27.6266 15.525 30.976 15.6117 30.546 13.3486C29.9765 11.8399 27.5814 12.0247 27.5814 12.0247L3.44166 13.922Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.44171 13.922C3.40399 12.6961 2.8269 9.35053 6.00278 8.50187C9.17867 7.65321 17.8162 7.26848 20.679 6.93656C23.5418 6.60464 26.1255 7.29111 26.9327 9.12045C27.7398 10.9498 27.5814 12.0248 27.5814 12.0248L3.44171 13.922Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.295 7.82289C10.295 7.82289 7.96775 9.84836 9.74428 11.7418C10.0988 10.267 10.6043 8.56594 12.973 7.56641C11.4265 7.77009 10.295 7.82289 10.295 7.82289Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5573 7.45336C14.5573 7.45336 12.23 9.48261 14.0028 11.3761C14.3574 9.90128 14.8628 8.23413 17.2315 7.22705L14.5573 7.45336Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5479 7.13665C18.5479 7.13665 16.3715 9.1244 18.1518 11.0179C18.5064 9.54308 18.8195 7.92873 21.1693 6.9292C19.6229 7.04613 18.5479 7.13665 18.5479 7.13665Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11292">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.600586)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMDeliInactive;

MMDeliInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMDeliInactive.defaultProps = {
    className: null,
};
